import $ from 'jquery';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/alert';

var getBannerHeight = function getBannerHeight() {
  $('.alert-banner-fixed').removeClass('d-none');
  var height = $('#scroll-banner').outerHeight();
  $('.alert-banner-fixed').addClass('d-none');
  return height;
};

var toggleAnimation = function toggleAnimation(class1, class2, remove) {
  var breakpoint = window.cigna.screen.breakpoint;

  if (!['xs', 'sm'].includes(breakpoint)) {
    if (!$('.alert-banner-fixed').hasClass("animate__".concat(class1))) {
      if (remove) {
        $('.alert-banner-fixed').removeClass('d-none');
      }

      $('.alert-banner-fixed').removeClass("animate__".concat(class1)).removeClass("animate__".concat(class2)).addClass("animate__".concat(class1));
    }
  } else {
    $('.alert-banner-fixed').addClass('d-none');
  }
};

var toggleComboTransition = function toggleComboTransition(id, position, bannerHeight) {
  var windowScroll = $(window).scrollTop();
  var idPosition = $(id).offset().top;
  var idHeight = $(id).outerHeight();
  var idBottom = idPosition + idHeight;
  var bottomScreen = windowScroll + $(window).innerHeight();
  var isScrollDown = windowScroll > position;
  var isScrollUp = windowScroll < position;
  var isInViewPort = bottomScreen > idPosition && windowScroll < idBottom;

  if (id === '#scroll-hero') {
    if (isScrollDown) {
      if (windowScroll >= bannerHeight + idPosition && isInViewPort) {
        toggleAnimation('fadeInDown', 'fadeOutUp', true);
      }
    } else if (isScrollUp && windowScroll <= bannerHeight + idPosition && isInViewPort) {
      toggleAnimation('fadeOutUp', 'fadeInDown', false);
    }
  }

  if (id.indexOf('.scroll-promo') > -1) {
    if (isScrollDown) {
      if (isInViewPort) {
        toggleAnimation('fadeOutUp', 'fadeInDown', false);
      }
    } else if (isScrollUp) {
      if (bottomScreen < idPosition && windowScroll > $('#scroll-hero').offset().top + $('#scroll-hero').outerHeight()) {
        toggleAnimation('fadeInDown', 'fadeOutUp', true);
      }
    }
  }
};

var isTabbing = false;

var onScroll = function onScroll(position, bannerHeight) {
  if (!isTabbing) {
    toggleComboTransition('#scroll-hero', position, bannerHeight);
    $('[class^=scroll-promo]').each(function (i) {
      toggleComboTransition(".".concat($($('[class^=scroll-promo]')[i]).prop('classList')[0]), position, bannerHeight);
    });
  } else {
    $('.alert-banner-fixed').removeClass('animate__fadeInDown').addClass('animate__fadeOutUp').addClass('d-none');
  }
};

export default (function () {
  $(document.body).on('click', '[data-dismiss="browser-warning"]', function (evt) {
    evt.preventDefault();
    var alertBox = $(evt.currentTarget).closest('.alert-banner');
    alertBox.removeClass('show').detach().remove();
  });
  $(document.body).on('keydown', function (evt) {
    var tabKeyPressed = evt.keyCode ? evt.keyCode === 9 : evt.which === 9;
    var shiftKeyPressed = evt.shiftKey;
    isTabbing = tabKeyPressed || tabKeyPressed && shiftKeyPressed;
  });
  var bannerHeight = getBannerHeight();
  var position = $(window).scrollTop();

  if ($('[class^=scroll-promo], #scroll-hero').length > 0) {
    $(window).on('scroll', function () {
      var scroll = $(window).scrollTop();
      onScroll(position, bannerHeight);
      position = scroll;
    });
  }
});